<template>
  <div>
    <!-- ok保增员活动分享 -->
    <van-action-sheet v-model="visible">
      <div class="content">
        <div class="title">邀请好友</div>
        <ul>
          <li @click="share('wx')">
            <img src="@/static/images/activityCenter/wx.png" alt="" />
            邀请好友
          </li>
          <li @click="share('pyq')">
            <img src="@/static/images/activityCenter/pyq.png" alt="" />
            转发朋友圈
          </li>
          <!-- <li @click="copy(), (visible = false)" id="copy">
            <img src="@/static/images/activityCenter/fzlj.png" alt="" />
            复制链接
          </li> -->
          <li @click="downloadImg()" v-if="download">
            <img src="@/static/images/activityCenter/xz.png" alt="" />
            下载邀请海报
          </li>
        </ul>
      </div>
    </van-action-sheet>
    <canvas id="myCanvas" style="display: none"></canvas>
    <vueQr ref="vueQr" :text="h5Link" v-if="h5Link" :margin="0" :width="200" style="display: none" />
    <!-- 引导分享 -->
		<div class="yindao" v-if="showYindao" @click="showYindao = false"></div>
  </div>
</template>

<script>
import vueQr from 'vue-qr';
import Clipboard from 'clipboard';
export default {
  props:{
    download:{
      type:Boolean,
      default:true
    }
  },
  components: { vueQr },
  data() {
    return {
      h5Link: '',
      posterImg: '',
      showYindao: false,
      visible: false,
    };
  },
  created() {
    this.init();
  },
  methods: {
    open() {
      this.visible = true;
    },
    async init() {
      const userInfo = JSON.parse(localStorage.getItem('jzy_user'));
      const topOrgId = await this.getTopId(userInfo.orgId);
      this.h5Link = location.origin + `/apps/signRegister?orgId=${topOrgId}&userId=${userInfo.userId}&noCheck=1`;
      if (this.$config.isApp) {
        await this.getLink();
      }
      this.shareData = {
        type: 1,
        title: '下载OK保，一起来赚钱吧！',
        link: this.h5Link,
        content: '登陆CCTV大品牌，千款优质好保险，精选好产品，理赔更无忧！', //分享的描述,
        logo: 'https://file-test.lazhuyun.cn/upload/20230904/1693820572564020449.png'
      };
      this.$weixin.share(this.shareData);
      window.setTimeout(() => {
        this.getImg();
      }, 0);
    },
    getImg() {
      const that = this;
      // 获取Canvas元素和上下文
      const canvas = document.getElementById('myCanvas');
      const context = canvas.getContext('2d');
      // 创建两个Image对象
      const image1 = new Image();
      const image2 = new Image();

      image1.setAttribute('crossOrigin', 'anonymous');
      image2.setAttribute('crossOrigin', 'anonymous');
      // 设置图片源
      image1.src = "https://file-test.lazhuyun.cn/upload/20240530/1717033293111561054.png";
      image2.src = this.$refs.vueQr.$el.src;
      // 当两张图片都加载完成后，执行合成操作
      image1.onload = function () {
        // 设置Canvas的尺寸和绘制图片
        canvas.width = image1.width;
        canvas.height = image1.height;
        // 绘制图片1
        context.drawImage(image1, 0, 0);

        // 绘制图片2
        context.drawImage(image2, 520, 728, 130, 130);

        // 合成完成后，可以将Canvas的内容导出为一张合成后的图片
        const compositeImage = canvas.toDataURL('image/jpeg', 0.8);
        that.upload(compositeImage);
      };
    },
    upload(baseStr, index) {
      let imgBase = baseStr;
      let blob = this.dataURLtoFile(imgBase, 'image/jpeg');
      var formData = new FormData();
      let fileOfBlob = new File([blob], new Date() + '.jpg'); // 重命名了
      formData.append('faceInfo', fileOfBlob);
      this.$http({
        url: '/resmgr/upload',
        data: formData,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(res => {
        this.posterImg = res.data[0].path;
        if (this.loading) {
          this.downloadImg();
        }
      });
    },
    dataURLtoFile(dataURI, type) {
      let binary = atob(dataURI.split(',')[1]);
      let array = [];
      for (let i = 0; i < binary.length; i++) {
        array.push(binary.charCodeAt(i));
      }
      return new Blob([new Uint8Array(array)], { type: type });
    },
    downloadImg() {
      if (!this.posterImg) {
        this.loading = true;
        return;
      }
      const filename = '宣传海报.jpg';
      const url = this.posterImg;
      if (this.$config.isApp) {
        this.$app.download(
          {
            type: 'image',
            url
          },
          res => {
            this.$notice.msg('保存成功');
          },
          res => {
            this.$notice.msg('保存失败');
          }
        );
      } else {
        const link = document.createElement('a');
        link.href = url;
        link.download = filename;
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
      this.loading = false;
      this.visible = false;
    },
    // 获取商户机构id
    getTopId(orgId) {
      return this.$http({
        url: '/api/userAuth/queryOrgIdBySub',
        type: 'GET',
        data: {
          subOrgId: orgId
        }
      }).then(res => {
        return res.data;
      });
    },
    getLink() {
      return this.$http({
        url: '/api/tools/transformLongUrl',
        type: 'PUT',
        data: { 
          url: this.h5Link,
          type: 1
        }
      }).then(res => {
        this.h5Link = res.data;
      });
    },
    copy() {
      const text = this.h5Link;
      var clipboard = new Clipboard('#copy', {
        text: trigger => {
          return text;
        }
      });
      clipboard.on('success', e => {
        this.$notice.msg('链接复制成功');
        // 释放内存
        clipboard.destroy();
      });
    },
    share(target) {
      const shareData = {
        type: 1,
        title: '下载OK保，一起来赚钱吧！',
        link: this.h5Link,
        content: '登陆CCTV大品牌，千款优质好保险，精选好产品，理赔更无忧！', //分享的描述,
        logo: 'https://file-test.lazhuyun.cn/upload/20230904/1693820572564020449.png'
      };
      if (this.$config.isApp) {
        this.$app.openShare({
          ...shareData,
          target
        });
      } else {
        this.visible = false;
        this.showYindao = true;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.content {
  padding: 50px 0;
  padding-bottom: 80px;
  .title {
    text-align: center;
    font-size: 34px;
    color: #333333;
    position: relative;
    &::before {
      content: '';
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      height: 0.013rem;
      background: #e2e2e2;
      width: 140px;
      left: 50px;
    }
    &::after {
      content: '';
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      height: 0.013rem;
      background: #e2e2e2;
      width: 140px;
      right: 50px;
    }
  }
  ul {
    display: flex;
    justify-content: space-around;
    align-items: center;
    margin-top: 40px;
    padding: 0 50px;
    li {
      display: flex;
      flex-direction: column;
      align-items: center;
      font-size: 28px;
      color: #333333;
      img {
        width: 68px;
        margin-bottom: 20px;
      }
    }
  }
}
.yindao {
  width: 100%;
  height: 100vh;
  background: url(~@/static/images/yindao2.png) no-repeat;
  background-size: 562px 266px;
  background-position: 140px 20px;
  position: fixed;
  left: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.5);
}
</style>
